<template>
    <div class="copybook-result" :style="{border: showOutline ? '1px dashed rgba(0, 0, 0, .12)' : 'none'}">
        <div class="row-list">
            <div class="row-item" v-for="row in renderArr">
                <div class="grid-list">
                    <div class="grid-item"
                         v-for="r in row"
                        >
                        <div v-if="r === ' '">
                            <div class="blank" :style="{width: options.blankSize + 'px'}">　</div>
                        </div>
                        <div v-if="r !== ' '">
                            <div class="pinyin" :style="{'font-size': fontSize + 'px'}">{{ r }}</div>
                            <div class="grid">
                                <img class="bg svg" :src="`/static/img/bg${options.types}${options.color}.jpg`"
                                    :style="{width: options.gridSize + 'px', height: options.gridSize + 'px'}"></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const pydic = window.pydic
    let arr = pydic.split(',')
    let pinyinMap = {}
    for (let item of arr) {
        pinyinMap[item[0]] = item.substring(1)
    }
    // console.log(pinyinMap)

    export default {
        data() {
            return {
                renderArr2: [
                    ['pīn', 'yin', '', 'pīn', 'yin', '', 'pīn', 'yin', 'pīn', '', 'yin', 'pīn', 'yin', 'pīn', 'yin'],
                    ['pīn', 'yin'],
                ]
            }
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        types: '',
                        color: '2',
                        typez: 'zi',
                        blank: '0',
                        gridSize: 80,
                        blankSize: 10,
                    }
                }
            },
            input: {
                type: String,
                default: ''
            },
            showOutline: {
                type: Boolean,
                default: false
            },
            paths: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        computed: {
            renderArr() {
                let str = this.input
                let arr = str.split('\n').filter(item => item)
                // console.log('arr', arr)
                let renderArr = arr.map(item => {
                    let results = []
                    for (let char of item) {
                        if (char.match(/[\u4e00-\u9fa5]/)) {
                            if (pinyinMap[char]) {
                                results.push(pinyinMap[char])
                            } else {
                                results.push('?')
                            }
                        } else {
                            results.push(char)
                        }
                    }
                    return results
                })
                // for (let cc of arr) {
                //     let str = ''
                //     let s
                //     let results = []
                //     for (let i = 0; i < cc.length; i++) {
                //         if (pydic.indexOf(cc.charAt(i)) !== -1 && cc.charCodeAt(i) > 200) {
                //             s = 1
                //             while (pydic.charAt(pydic.indexOf(cc.charAt(i)) + s) !== ',') {
                //                 str += pydic.charAt(pydic.indexOf(cc.charAt(i)) + s)
                //                 s++
                //             }
                //             results.push(str)
                //             str = ''
                //             // str += ' '
                //         } else {
                //             str += cc.charAt(i)
                //         }
                //     }
                //     // console.log(results)
                //     renderArr.push(results)
                // }
                // console.log('renderArr', renderArr)
                return renderArr
            },
            fontSize() {
                return 20
                // if (this.options.gridSize >= 80) {
                //     return 30
                // }
                // if (this.options.gridSize <= 60) {
                //     return 20
                // }
                // return 20 + (this.options.gridSize - 60) / 2
            }
        },
        mounted() {
            console.log('query', this.$route.query)
            if (this.$route.query.gridSize) {
                this.options.gridSize = parseInt(this.$route.query.gridSize)
            }
            if (this.$route.query.blankSize) {
                this.options.blankSize = parseInt(this.$route.query.blankSize)
            }
            // console.log('这是', this.translate('动'))
        },
        methods: {
            translate(text) {
                // /^[\u4e00-\u9fa5]$/
                let results = []
                for (let char of text) {
                    if (pinyinMap[char]) {
                        results.push(pinyinMap[char])
                    } else {
                        results.push('')
                    }
                }
                console.log('results', results)
                return results
                // this.inputStr = this.input.split('')
            },
            removeTune(pinyin) {
                return pinyin.replace(/[āáǎà]/, 'a')
                    .replace(/[ōóǒò]/, 'o')
                    .replace(/[ēéěè]/, 'e')
                    .replace(/[īíǐì]/, 'i')
                    .replace(/[ūúǔù]/, 'u')
                    .replace(/[ǖǘǚǜ]/, 'ü')
            }
            // translate(str) {
            //     let arr = str.split(' ')
            //     let renderArr = []
            //     for (let cc of arr) {
            //         let str = ''
            //         let s
            //         let results = []
            //         for (let i = 0; i < cc.length; i++) {
            //             if (pydic.indexOf(cc.charAt(i)) !== -1 && cc.charCodeAt(i) > 200) {
            //                 s = 1
            //                 while (pydic.charAt(pydic.indexOf(cc.charAt(i)) + s) !== ',') {
            //                     str += pydic.charAt(pydic.indexOf(cc.charAt(i)) + s)
            //                     s++
            //                 }
            //                 results.push(str)
            //                 str = ''
            //                 // str += ' '
            //             } else {
            //                 str += cc.charAt(i)
            //             }
            //         }
            //         // console.log(results)
            //         renderArr.push(results)
            //     }
            //     console.log(renderArr)
            //     this.renderArr = renderArr
            // }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/var";
    .blank {
        width: 10px;
        flex-shrink: 0;
    }
    .pinyin {
        font-size: 30px;
        text-align: center;
        font-family: "SimSun";
    }
    .grid-list {
        display: flex;
        flex-wrap: wrap;
        margin-right: -8px;
        .grid-item {
            // float: left;
            margin-right: 8px;
        }
    }
    .copybook-result {
        width: 938px;
        margin: 0 auto;
        padding-left: 2px;
        .bg {
            width: 40px;
            height: 40px;
            font-family: 'KaiTi', 'KaiTi_GB2312';
            font-size: 58px;
            text-align: center;
            // line-height: 80px;
            background: url('/static/img/bg2.jpg');
            margin: 4px 0px 5px -2px;
            color: #b8b8b8;
            .bold {
                color: #000;
            }
            svg {
                margin: 16px;
            }
        }
        .grid {

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pinyin-book/index.vue